import { Checkbox as CheckboxUI } from '@sloyd/ui';
import { useEffect, useState } from 'react';
import { useKey } from 'react-use';

type CheckboxProps = {
  id: string;
  value?: boolean;
  onPatch: (value: Json) => void;
  label: string;
  fieldId: string;
  hotkey: string;
};

export function Checkbox(props: CheckboxProps) {
  const { label, fieldId, hotkey } = props;
  const [value, setValue] = useState(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value, props.id]);

  const onChange = (ev: any) => {
    const value = ev.target.checked;
    props.onPatch({ [fieldId]: value });
    setValue(value);
  };

  useKey(
    hotkey,
    () => {
      setValue(!value);
      props.onPatch({ [fieldId]: !value });
    },
    { event: 'keydown' },
    [value]
  );

  return <CheckboxUI onChange={onChange} checked={value} label={label} />;
}
